import { ykDateFormat } from '@/public/utils/globalFunc.js'
// 日期
export function VDate(el, binding, vnode) {
  const value = ykDateFormat('yyyy-MM-dd', vnode.data.model.value)
  vnode.data.model.callback(value)
}
// 时间
export function VDatetime(el, binding, vnode) {
  const value = ykDateFormat('yyyy-MM-dd HH:mm:ss', vnode.data.model.value)
  vnode.data.model.callback(value)
}